import React from "react";

const SectionHeading = ({ children, centered = true, className = "" }) => {
  return (
    <div
      className={`mb-12 ${centered ? "text-center" : "text-left"} ${className}`}
    >
      <h2 className="section-heading text-[#1A1C25]">{children}</h2>
      <div
        className={`mt-3 h-1.5 w-20 bg-[#F4B400] rounded-full ${centered ? "mx-auto" : "ml-0"}`}
      />
    </div>
  );
};

export default SectionHeading;
